import React from 'react'
// libs
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
// components
import MainLayoutContainer from 'containers/MainLayout'
import NavigationSidebar from 'components/UI/NavigationSidebar'
// view components
import Filter from './components/Filter'
import UsedCard from './components/Result'
// themes
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const ContentContainer = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;
`

const AiUsage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Skefto - AI Usage</title>
      </Helmet>
      <MainLayoutContainer>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <ContentContainer>
            <Filter />
            <UsedCard />
          </ContentContainer>
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default AiUsage
